<template lang="pug">
  v-row
    v-col(cols="12")
      LobbyNames(v-model="form.names", :title="translations.label.names", :labelName="translations.label.nameslabel" @input="emitValues", :clearForm="clearForm")
    v-col(cols="12" sm="6")
      BaseTextField(v-model="form.icon", :label="translations.label.icon" @input="emitValues")
      p Listado de iconos disponibles de material:
        |
        |
        a(href="https://materialdesignicons.com/" target="_blank") link
    v-col(cols="12" sm="6")
      BaseTextField(rules="host" v-model="form.img", :label="translations.label.img" @input="emitValues")
    v-col(cols="12")    
      BaseChipSelectField(rules="required", :items="gamesListAll" v-model="form.games", :label="translations.label.games" @input="emitValues" @addedItem="addedItem" @deleteItem="deleteItem")
</template>

<script>

  import LobbyNames from "./LobbyNames";

  export default {
    name: "LobbyCategory",
    components: {
      LobbyNames,
    },
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      gamesListAll: {
        type: Array,
        default: function(){
          return []
        }
      },
      lobby: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() =>({
      form:{
        names: [],
        icon: '',
        img: '',
        games: [],
      },
    }),
    watch: {
      clearForm: function(val){
        if (val){
          if(this.lobby != undefined && this.lobby.names != undefined && this.lobby.names.length > 0){
            this.setFields(this.lobby);
          } else {
            this.clearFields();
          }
        }
      },
      lobby: function(val){
        this.setFields(val);
      },
    },
    created(){
      this.setFields(this.lobby);
    },
    methods:{
      addedItem(item){
        this.$emit('addedItem', item);
      },
      deleteItem(item){
        this.$emit('deleteItem', item);
      },
      emitValues(){
        this.$emit('input', this.form);
      },
      clearFields(){
        this.form.names = [];
        this.form.icon = '';
        this.form.img = '';
        this.form.games = [];
      },
      setFields(val){
        if (val.names != undefined && val.names.length > 0){
          this.form.names = val.names;
          this.form.icon = val.icon;
          this.form.img = val.img;
          this.form.games = val.games;
        }
      },
    },
  }
</script>

<style lang="sass">
</style>